import React from "react";
import { createGlobalStyle } from "styled-components";

import {
  FontCastledownEOT,
  FontCastledownTTF,
  FontCastledownWOFF,
  FontCastledownWOFF2,
  FontSatoshiBoldWOFF,
  FontSatoshiBoldWOFF2,
  FontSatoshiMediumWOFF,
  FontSatoshiMediumWOFF2,
  FontSatoshiRegularWOFF,
  FontSatoshiRegularWOFF2,
} from "src/static/fonts";

const castledownSrc = `
  src: url(${FontCastledownEOT});
  src: url(${FontCastledownEOT}#iefix) format("embedded-opentype"),
       url(${FontCastledownWOFF2}) format("woff2"),
       url(${FontCastledownWOFF}) format("woff"),
       url(${FontCastledownTTF}) format("truetype");
`;

// Single heavy master registered at the weights the graphic uses, so
// Safari/Chrome don't synthesize different bold/light metrics.
const castledownFaces = [300, 400, 700, 900]
  .map(
    (weight) => `
  @font-face {
      font-family: "Castledown";
      ${castledownSrc}
      font-weight: ${weight};
      font-style: normal;
      font-display: swap;
  }`
  )
  .join("");

const CustomStyles = createGlobalStyle`
  ${castledownFaces}

  @font-face {
    font-family: "Satoshi";
    font-style:  normal;
    font-weight: 400;
    src: url(${FontSatoshiRegularWOFF2}) format("woff2"),
        url(${FontSatoshiRegularWOFF}) format("woff");
  }
  @font-face {
    font-family: "Satoshi";
    font-style:  normal;
    font-weight: 500;
    src: url(${FontSatoshiMediumWOFF2}) format("woff2"),
        url(${FontSatoshiMediumWOFF}) format("woff");
  }
  @font-face {
    font-family: "Satoshi";
    font-style:  normal;
    font-weight: 700;
    src: url(${FontSatoshiBoldWOFF2}) format("woff2"),
        url(${FontSatoshiBoldWOFF}) format("woff");
  }

  html {
    height: 100%;
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }

  p {
    margin: 0
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }
`;

const GlobalStyles = () => (
  <>
    <CustomStyles />
  </>
);

export default GlobalStyles;
